<template>
  <div class="site-view">
    <!--Map Image modal-->
    <div v-if="modalShow" class="ImgModal modalShown">
      <div class="schemeImg">
        <div
          :style="{
            'background-image': `url(${require('@/assets/images/CycleRoute/mapOverview.jpg')})`,
          }"
        ></div>
      </div>
      <div @click="closeModal" class="close">
        <div
          :style="{
            'background-image': `url(${require('@/assets/images/CycleRoute/CloseBTN.svg')})`,
          }"
        ></div>
      </div>
    </div>
    <!--Map Image modal-->
    <section v-if="!pageData" class="site-2col">
      <div class="container">
        <div class="row mb-0">
          <div class="fixedCentre">
            <h2>Loading, please wait...</h2>
          </div>
        </div>
      </div>
    </section>

    <section v-if="pageData" class="background-cover">
      <video
        playsinline
        autoplay
        muted
        loop
        poster="@/assets/images/CycleRoute/M5J19_BannerAnimation_FirstFrame_v4.png"
        id="bgvid"
      >
        <source
          src="https://player.vimeo.com/external/507442596.hd.mp4?s=2196b2d3ea06355a432246f2890074b324d00215&profile_id=175"
          type="video/mp4"
        />
      </video>
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col s12 m12 l12 textBG">
              <h1 class="subheading">{{ pageData.properties.pageTitle }}</h1>
              <h1 class="sub-subheading">Public Engagement</h1>
              <h1>10th February to 17th March – Feedback survey now closed</h1>
              <h1></h1>
              <!-- <router-link to="/map">{{ pageData.properties.bannerLinkText }}</router-link> -->
            </div>
          </div>
        </div>
      </div>
      <div class="arrow bounce">
        <p><i class="material-icons">arrow_downward</i></p>
        <!-- <p><small>Scroll Down</small></p> -->
      </div>
    </section>
    <section v-if="pageData" class="site-2col site-topstrip site-treebg">
      <div class="container">
        <div class="row">
          <div class="col s12 m12 l6 ourPlans">
            <h2>Our plans for the Cycleway</h2>
            <p>
              This year we will start building a continuous cycleway to the
              B4063 connecting Gloucester, Cheltenham and the villages in
              between. We want to hear what you think about our plans for the
              section of the B4063 Cycleway from Elmbridge Court Roundabout to
              Arle Court Roundabout.
            </p>
            <p>
              Your feedback will help shape the scheme going forward, making
              sure the final plan provides a safe, convenient and direct route
              between Gloucester and Cheltenham.
            </p>
            <p>
              We know this scheme could cause some limited disruption while it
              is being built, so please tell us in your feedback what we can do
              to make this change easier for everyone before we start.
            </p>
            <p>
              This is also your opportunity to show us your enthusiasm for
              cycling, tackling climate change, and other parts of our vision
              for the county. We want to reach a broad and diverse selection of
              people which truly reflects the views of everyone affected by or
              who has an interest in this cycle route, so please share this
              survey with you friends, family and neighbours.
            </p>
          </div>
          <div class="col s12 m12 l6 ourPlansimg">
            <!-- <div class="iframe-wrapper" v-html="pageData.properties.infoSectionAsset"></div> -->
            <img
              class="mapPrev"
              src="@/assets/images/CycleRoute/mapOverview.jpg"
              alt=""
              @click="openModal"
            />
          </div>
        </div>
      </div>
    </section>

    <section v-if="pageData" class="site-timeline">
      <div class="container">
        <div class="row">
          <div class="col s12 m12 l12" style="margin: 40px 0">
            <h2>What happens next?</h2>
            <p>
              We will use your feedback alongside further technical work to
              finalise (and, if needed, modify) detailed scheme designs so that
              the scheme will truly reflect the needs and requirements of people
              in Gloucestershire. We will publish a summary report on the survey
              results too.
            </p>
            <p>
              We will then begin searching for a contractor to construct the
              Cycleway, using our established competitive tender process. The
              scheme is currently designed to fit within the existing highway
              boundary, meaning that once the scheme designs and contractor is
              chosen, we can start to build the Cycleway.
            </p>
            <ul class="timeline" style="margin-top: 100px !important">
              <li>
                <div class="timeline-card">
                  <h2>Draft scheme designs</h2>
                </div>
                <span class="date">Autumn 2020 to early Spring 2021</span>
              </li>
              <li>
                <div class="timeline-card">
                  <h2>Public Engagement period</h2>
                </div>
                <span class="date">Early Spring 2021</span>
              </li>
              <li>
                <div class="timeline-card">
                  <h2>Feedback analysis & finalising designs</h2>
                </div>
                <span class="date">Spring 2021</span>
              </li>
              <li>
                <div class="timeline-card">
                  <h2>Tender process open for submission</h2>
                </div>
                <span class="date">Spring to early summer 2021</span>
              </li>
              <li>
                <div class="timeline-card">
                  <h2>Construction contract awarded</h2>
                </div>
                <span class="date">Summer 2021</span>
              </li>
              <li>
                <div class="timeline-card">
                  <h2>Construction</h2>
                </div>
                <span class="date">Summer 2021 to Spring 2022</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="pageData"
      class="site-bannerbox"
      :style="{ backgroundImage: `url(${backgroundUrl2})` }"
    >
      <div class="container">
        <div class="row">
          <div class="col s12 m12 l6">
            <div class="box">
              <h2>How to have your say</h2>
              <p>
                Take some time to explore our
                <router-link to="/site/furtherInfoPage">proposals</router-link>,
                then provide your feedback using our
                <router-link to="/site/FeedbackSurvey">survey</router-link>.
              </p>
              <router-link to="/site/FeedbackSurvey" class="banner-btn"
                >Open Survey</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <SiteFooter v-if="pageData" />
  </div>
</template>

<script>
import firebase from "firebase";
import Settings from "@/mixins/AppSettings.js";
import { mapState, mapGetters } from "vuex";
import Logo from "@/assets/images/heathrow/logo.png";
import Branding from "@/components/Branding";
import backgroundUrl from "@/assets/images/template/home/hero.jpg";
import backgroundUrl2 from "@/assets/images/template/home/questionnaire.jpg";
import Apicall from "@/mixins/Apicall";
import SiteFooter from "@/components/customPages/components/footer.vue";
import _ from "lodash";
import ImgModal from "@/components/ImgModal.vue";

export default {
  name: "homePage",
  components: {
    Branding,
    SiteFooter,
    ImgModal,
  },
  data() {
    return {
      fields: {
        name: "",
        email: "",
        address: "",
        postcode: "",
        telephone: "",
        message: "",
        checkedDoc: [],
      },
      backgroundUrl: backgroundUrl,
      backgroundUrl2: backgroundUrl2,
      modalShow: false,
    };
  },
  computed: {
    ...mapState(["entities", "entityTypes"]),
    ...mapGetters(["user", "allEntityTypes", "allEntities"]),
    pageData() {
      if (this.$route.params.id != undefined) {
        return this.allEntities.find(
          (item) => item.docId == this.$route.params.id
        );
      } else {
        return this.allEntities.find(
          (item) => item.type == this.$route.params.templateName
        );
      }
    },

    timelineInfo: function () {
      if (this.pageData.length !== 0 && this.pageData.children) {
        return _.orderBy(
          this.allEntities.filter((item) => {
            return (
              this.pageData.children.timelineItem.indexOf(item.docId) != -1
            );
          }),
          "properties.date",
          "asc"
        );
      }
    },
  },
  async mounted() {
    if (this.entities.length == 0) {
      //debugger
      await this.$store.dispatch("populateEntities");
    }

    // this.populateTimeline();
  },
  methods: {
    async submitForm(event) {
      var messageBody = "";

      for (let item in this.fields) {
        messageBody += "<p>" + item + ":" + this.fields[item] + "</p>";
      }

      let bodyData = {
        subject: "Contact Information M5 Contact Form",
        messageBody: messageBody,
      };
      let results = await Apicall.submitForm(bodyData);
      if (results.status == "200") {
        M.toast({
          html: "Message sent, thank you.",
          classes: "blue",
        });

        this.fields = {
          name: "",
          email: "",
          address: "",
          postcode: "",
          telephone: "",
          message: "",
          checkedDoc: [],
        };
        console.log("Submitted");
      } else {
        M.toast({
          html: "Something went wrong. Please try again",
          classes: "error",
        });
        console.log("Please try submitting again");
      }
    },

    openModal() {
      this.modalShow = true;
    },

    closeModal() {
      this.modalShow = false;
    },
  },
  watch: {
    $route(to, from) {
      this.activeInstance = to.params.root;
    },
    pageData(to, from) {
      // this.populateTimeline();
    },
  },
};
</script>

<style lang="scss" scoped>
.mapPrev {
  cursor: pointer;

  @media screen and (max-width: 990px) {
    cursor: default;
  }
}

.sub-subheading {
  margin: 0 !important;
}

.ImgModal {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  background-color: #fafafa;
  padding: 0;
  // max-height: 70%;
  width: 70%;
  margin: auto;
  overflow-y: auto;

  border-radius: 2px;
  will-change: top, opacity;

  &.modalShown {
    display: block;
    z-index: 40;
    top: 150px;
  }

  .schemeImg {
    width: 100%;
    height: 60vh;

    div {
      width: 100%;
      height: 100%;

      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  @media screen and (max-width: 990px) {
    &.modalShown {
      display: none;
    }
  }
}

.close {
  width: 40px;
  height: 40px;
  position: absolute;

  top: 20px;
  right: 20px;

  div {
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-size: contain;

    position: relative;
  }
}

.ourPlans {
  margin-bottom: 200px;

  @media screen and (max-width: 990px) {
    margin-bottom: 100px;
  }
}

.ourPlansimg {
  @media screen and (max-width: 990px) {
    margin-bottom: 100px !important;
  }
}
</style>
